import React from 'react';

export function Divider({ orientation = 'horizontal', label, className = '', ...rest }) {
  if (label) {
    return (
      <div className={['sp-divider--labeled', className].filter(Boolean).join(' ')} {...rest}>
        <span className="sp-label">{label}</span>
      </div>
    );
  }
  return (
    <hr
      className={['sp-divider', orientation === 'vertical' && 'sp-divider--vertical', className].filter(Boolean).join(' ')}
      {...rest}
    />
  );
}
